

export const ErrorMessages = {
    "INVALID_INPUT": "ERROR_CODE.INVALID_INPUT",
    "WENT_WRONG": "ERROR_CODE.WENT_WRONG",
    "OTP_FAILED": "ERROR_CODE.OTP_FAILED",
    "OTP_EXPIRED": "ERROR_CODE.OTP_EXPIRED",
    "INVALID_VERIFICATION_TOKEN": "RESET_PASSWORD.VERIFY_TOKEN.INVALID_VERIFICATION_TOKEN",
    "VERIFICATION_TOKEN_NOT_FOUND": "RESET_PASSWORD.VERIFY_TOKEN.VERIFICATION_TOKEN_NOT_FOUND",
    "INVALID_LINK": "RESET_PASSWORD.VERIFY_TOKEN.INVALID_LINK",
    "ACCOUNT_BLOCKED":"ERROR_CODE.ACCOUNT_BLOCKED",
    "INTERNAL_SERVER_ERROR":"ERROR_CODE.WENT_WRONG",
    "02301003":"RESET_PASSWORD.VERIFY_TOKEN.INVALID_LINK",
    "02301036":"ERROR_CODE.ACCOUNT_BLOCKED",
    "02301043":"ERROR_CODE.ACCOUNT_BLOCKED",
    "02301029":"ERROR_CODE.WENT_WRONG",
    "02301001": "ERROR_CODE.WENT_WRONG"
}